exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-information>.booking-confirmation .main-message[data-v-37d6cd78]{color:#9f4378}dl.term-description dt[data-v-37d6cd78]{color:#9e4d84}.totalbutton[data-v-37d6cd78]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.swal-button[data-v-37d6cd78]{padding:0!important}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-37d6cd78]{font-size:1.5em}h2[data-v-37d6cd78]{font-size:1.4em}a.button.btn-large[data-v-37d6cd78],button.btn-large[data-v-37d6cd78],input[type=button].button.btn-large[data-v-37d6cd78]{font-size:1em}.booking-information[data-v-37d6cd78]{padding:20px 15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37d6cd78","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/success/Success.vue
// module id = 620
// module chunks = 0